import React, { useRef, useEffect, useState } from 'react';

const getVimeoId = (url) => {
    const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return match ? match[1] : null;
};

const VimeoPlayer = ({ vimeoUrl, onProgress, onComplete,watch_time }) => {
    const iframeRef = useRef(null);
    const [player, setPlayer] = useState(null);
    const [duration, setDuration] = useState(0);
    const [completed, setCompleted] = useState(false);

    useEffect(() => {
        if (player && typeof watch_time === 'number' && watch_time > 0) {
            player.setCurrentTime(watch_time).catch(() => {});
        }
        // eslint-disable-next-line
    }, [player, watch_time]);
    useEffect(() => {
        if (!vimeoUrl) return;
        const vimeoId = getVimeoId(vimeoUrl);
        if (!vimeoId) return;

        // Load Vimeo Player API
        const scriptId = 'vimeo-player-api';
        if (!document.getElementById(scriptId)) {
            const tag = document.createElement('script');
            tag.src = 'https://player.vimeo.com/api/player.js';
            tag.id = scriptId;
            document.body.appendChild(tag);
            tag.onload = initPlayer;
        } else {
            initPlayer();
        }

        function initPlayer() {
            // eslint-disable-next-line no-undef
            const Vimeo = window.Vimeo;
            if (!Vimeo) return;
            const p = new Vimeo.Player(iframeRef.current);
            setPlayer(p);

            
            
            p.on('timeupdate', (data) => {
                p.getDuration().then((duration)=>{
                    onProgress(data.seconds, duration)
                });
                
                if (data.percent >= 0.98 && !completed) {
                    setCompleted(true);
                    if (onComplete) onComplete();
                }
            });
        }

        return () => {
            if (player) player.unload();
        };
        // eslint-disable-next-line
    }, [vimeoUrl]);

    const vimeoId = getVimeoId(vimeoUrl);
    if (!vimeoId) return <div>Invalid Vimeo URL</div>;

    return (
        <div>
            <iframe
                ref={iframeRef}
                src={`https://player.vimeo.com/video/${vimeoId}?api=1&player_id=vimeo-player`}
                width="640"
                height="360"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
                title="Vimeo Player"
                 className="w-100 ms-auto me-auto"
            />
        </div>
    );
};

export default VimeoPlayer;